import VLibras from './Componentes/VLibras';
import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Evento from "./Evento";
import EventoEncerrado from "./EventoEncerrado";
import EventoPas from "./EventoPas";
import Menu from "./Componentes/Menu";
import Footer from "./Componentes/Footer";
import Concurso from "./Concurso";
import ConcursoPas from "./ConcursoPas";
import Erro404 from "./Erro404";
import { Config } from "./Config.js";

function redirecionarparaErro(basename) {
  return basename === "/pas/";
}
// inserção className
class App extends Component {
  render() {
    console.log(Config.basename);
    return (
      <div>
        <VLibras />
        <div className="site-shortcuts"> 
          <div className="shortcuts"> 
            <a className="sr-only sr-only-focusable" href="#main"> 
              <span>Ir para o conteúdo</span>
            </a>
          </div>
        </div>
        <div className="ajax_loader">
          <div className="ajax_loader_1">
            <div className="pulse" />
          </div>
        </div>

        <div className="wrapper">
          <div className="wrapper_inner">
            <header className="scroll_header_top_area light stick transparent scrolled_not_transparent page_header">
              <div className="header_inner clearfix">
                <div className="header_top_bottom_holder">
                  <div className="header_bottom clearfix">
                    <div className="container">
                      <div className="container_inner clearfix">
                        <div className="header_inner_left">
                          <div className="mobile_menu_button">
                            <span>
                              <i className="qode_icon_font_awesome fa fa-bars " />
                            </span>
                          </div>

                          <div className="logo_wrapper">
                            <div className="q_logo">
                              <a data-itemprop="url" href="/">
                                <img
                                  data-itemprop="image"
                                  className="normal"
                                  src="https://www.cebraspe.org.br/contents/data/2018/12/logo-cebraspe.png"
                                  alt="Logo"
                                />
                                <img
                                  data-itemprop="image"
                                  className="light"
                                  src="https://www.cebraspe.org.br/contents/data/2018/12/logo-cebraspe.png"
                                  alt="Logo"
                                />
                                <img
                                  data-itemprop="image"
                                  className="dark"
                                  src="https://www.cebraspe.org.br/contents/data/2018/12/logo-cebraspe.png"
                                  alt="Logo"
                                />
                                <img
                                  data-itemprop="image"
                                  className="sticky"
                                  src="https://www.cebraspe.org.br/contents/data/2018/12/logo-cebraspe.png"
                                  alt="Logo"
                                />
                                <img
                                  data-itemprop="image"
                                  className="mobile"
                                  src="https://www.cebraspe.org.br/contents/data/2018/12/logo-cebraspe.png"
                                  alt="Logo"
                                />
                              </a>
                            </div>
                          </div>
                        </div>

                        <div className="header_inner_right">
                          <div className="side_menu_button_wrapper right">
                            <div className="header_bottom_right_widget_holder">
                              <div className="header_bottom_widget widget_text">
                                <div className="textwidget">
                                  <p>
                                    <a
                                      className="header__action-follow-button"
                                      href="https://security.cebraspe.org.br/acompanhamento/default1.asp"
                                    >
                                      Página de acompanhamento{" "}
                                      <img
                                        alt="Ícone User"
                                        src="https://www.cebraspe.org.br/contents/data/2018/12/icone_pg_acompanhamento.png"
                                      />
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="side_menu_button" />
                          </div>
                        </div>
                        <Menu identificador={Config.menuSuperior} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="content">
              <div id="main" className="content_inner no_animation">
                <BrowserRouter basename={Config.basename}>
                  <div>
                    <Switch>
                      <Route
                        path="/"
                        exact
                        component={() =>
                          redirecionarparaErro(Config.basename) ? (
                            <Erro404 />
                          ) : (
                            <Evento />
                          )
                        }
                      />
                      <Route path="/pas" exact component={Erro404} />
                      <Route
                        path="/novos"
                        exact
                        render={(props) => <Evento {...props} fase={"novos"} />}
                      />
                      <Route
                        path="/inscricoes-abertas"
                        exact
                        render={(props) => (
                          <Evento {...props} fase={"inscricoes-abertas"} />
                        )}
                      />
                      <Route
                        path="/em-andamento"
                        exact
                        render={(props) => (
                          <Evento {...props} fase={"em-andamento"} />
                        )}
                      />
                      <Route
                        path="/encerrado"
                        exact
                        render={(props) => (
                          <EventoEncerrado {...props} fase={"encerrado"} />
                        )}
                      />
                      <Route path="/subprogramas" exact component={EventoPas} />
                      <Route
                        path="/subprogramas/:subprograma/:etapa"
                        exact
                        component={ConcursoPas}
                      />
                      <Route path="/:identificador" component={Concurso} />
                    </Switch>
                  </div>
                </BrowserRouter>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
